<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Edit Kontrak
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <!-- <div class="row mb-1">
                                            <div class="col-md-12">
                                                <p class="text-danger fst-italic fs-8 fw-bold">
                                                    * Wajib diisi
                                                </p>
                                            </div>
                                        </div> -->
                <p
                  class="mb-5"
                  style="
                    font-size: 2rem;
                    line-height: 1.5rem;
                    font-family: 'Inter-Bold';
                  "
                >
                  {{ formValues.namaKontrak }}
                </p>
                <div class="row mb-2">
                  <div class="col-md-4">
                    <label for="tingkatResiko" class="form-label fs-8 fw-bold"
                      >Tingkat Resiko</label
                    >
                    <select
                      class="form-select form-select-sm"
                      name="tingkatResiko"
                      id="tingkatResiko"
                      v-model="formValues.tingkatResiko"
                    >
                      <option
                        :value="row.value"
                        v-for="(row, indexz) in tingkatResiko"
                        :key="indexz"
                      >
                        {{ row.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label for="nilaiKontrak" class="form-label fs-8 fw-bold"
                      >Nilai Kontrak</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nilaiKontrak"
                      placeholder="Masukkan Nilai Kontrak"
                      v-model="formValues.nilaiKontrak"
                      @input="updateAmount"
                    />
                  </div>
                  <div class="col-md-4">
                    <label for="fileDokumenTOR" class="form-label fs-8 fw-bold"
                      >Dokumen TOR</label
                    >
                    <div class="input-group mb-1">
                      <input
                        type="file"
                        ref="fileDokumenTOR"
                        accept=".pdf"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFile('dokumenTOR')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.size"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max:
                      {{ max_file_size }}MB).
                    </div>
                    <div
                      v-if="validasiFile.type"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                    </div>
                    <div v-if="kontrak.torFile != null" class="fs-8">
                      File saat ini :
                      <a
                        class="text-danger pointer"
                        @click="downloadFile(kontrak.torFile)"
                        >Dokumen TOR {{ formValues.namaKontrak }}</a
                      >
>>>>>>> main
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-12">
                    <label for="ruangLingkup" class="form-label fs-8 fw-bold"
                      >Ruang Lingkup</label
                    >
                    <textarea
                      class="form-control fs-8"
                      id="exampleFormControlTextarea1"
                      rows="7"
                      v-model="formValues.ruangLingkup"
                      placeholder="Masukkan Ruang Lingkup"
                    ></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-end">
                    <button
                      type="button"
                      @click="clickSimpan()"
                      class="btn btn_cari w-25"
                    >
                      Simpan
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  // CMS_UPLOAD,
  CMS_SET_KONTRAK,
  CMS_DOWNLOAD,
  CMS_KONTRAK,
  CMS_UPLOAD_USECASE,
} from "../../constants.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url_simpan = API_BASE_URL + CMS_SET_KONTRAK;
// const url_upload = API_BASE_URL + CMS_UPLOAD
const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_get_kontrak = API_BASE_URL + CMS_KONTRAK;
const max_file_size = 5; // MB

export default {
  mixins: [GlobalDataMixin],
  name: "ProfilePage",
  components: {
    DefaultLayout,
    // Datepicker
  },
  data() {
    return {
      isLoading: false,
      tingkatResiko: [
        { value: 1, label: "Rendah" },
        { value: 2, label: "Rendah Menengah" },
        { value: 3, label: "Tinggi Menengah" },
        { value: 4, label: "Tinggi" },
      ],
      kontrak: {},
      formValues: {
        nomorNOA: "",
        nomorPO: "",
        namaKontrak: "",
        tanggalMulai: "",
        tanggalSelesai: "",
        tingkatResiko: { value: "", label: "" },
        nilaiKontrak: "",
        ruangLingkup: "",
        fileDokumenTOR: "",
      },
      validasiFile: {
        type: false,
        size: false,
      },
      server: "",
    };
  },
  mounted() {
    this.fetchData(this.$route.params.id);
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    fetchData(id) {
      var config = {
        headers: {
          // role: role,
          // Authorization: `Bearer ${tokens.token}`,
          // Accept: "application/json",
          // "Access-Control-Allow-Origin": "*",
          // "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          // "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
          role: this.userData.role,
          Authorization: "Bearer " + this.userData.token,
          accept: "*/*",
        },
      };
      axios
        .get(url_get_kontrak + "?id=" + id, config)
        .then((response) => {
          this.kontrak = response.data.data;
          this.formValues.namaKontrak = this.kontrak.title;
          this.formValues.nomorNOA = this.kontrak.oaNumber;
          this.formValues.nomorPO = this.kontrak.poNumber;
          this.formValues.tanggalMulai = this.kontrak.validityStart;
          this.formValues.tanggalSelesai = this.kontrak.validityEnd;
          this.formValues.ruangLingkup = this.kontrak.ruangLingkup;
          this.formValues.tingkatResiko =
            this.kontrak.tingkatResiko != null
              ? this.tingkatResiko.find(
                  (tr) => tr.value == this.kontrak.tingkatResiko,
                ).value
              : null;
          this.formValues.nilaiKontrak = this.formatCurrency(
            this.kontrak.nilaiKontrak,
          );
          this.server = this.kontrak.server;
        })
        .catch((error) => {
          alert("Error Fetch Data Detail Kontrak : " + error.message);
          console.error("Error fetching data:", error);
        });
    },

    async simpanEditKontraktor() {
      const fileDokumenTOR = this.$refs.fileDokumenTOR.files[0];
      // console.log('tp',this.formValues.tanggalPengesahan);
      let bodyJsonProfile = {
        id: this.$route.params.id,
        server: this.server,
        vendorNumber: this.userData.gemsCode,
        title: this.formValues.namaKontrak,
        oaNumber: this.formValues.nomorNOA,
        poNumber: this.formValues.nomorPO,
        // aribaId: string,
        validityStart:
          this.formValues.tanggalMulai != null &&
          this.formValues.tanggalMulai != ""
            ? moment(this.formValues.tanggalMulai).format("YYYY-MM-DD")
            : null,
        validityEnd:
          this.formValues.tanggalSelesai != null &&
          this.formValues.tanggalSelesai != ""
            ? moment(this.formValues.tanggalSelesai).format("YYYY-MM-DD")
            : null,
        detail: {
          tingkatResiko: this.formValues.tingkatResiko,
          ruangLingkup: this.formValues.ruangLingkup,
          nilaiKontrak: parseInt(
            this.formValues.nilaiKontrak.replace(/\D/g, ""),
          ),
        },
      };
      await axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanEditKontraktor : ", response);
          if (fileDokumenTOR != null) {
            this.uploadFile(fileDokumenTOR);
          } else {
            this.alertSukses();
          }
        })
        .catch((error) => {
          console.log("error simpanEditKontraktor : ", error);
          alert("error simpanEditKontraktor");
          this.isLoading = false;
          // if(error.response.status==500){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==400){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==401){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }
        })
        .then(() => {});
    },

    async uploadFile(file) {
      // let file = files

      if (file) {
        // Get the file name
        const fileName = file.name;

        // Create a FormData object and append the file
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", this.$route.params.id);
        formData.append("purpose", "tor");
        formData.append("usecase", "contract");

        // Make the API request to upload the file
        try {
          const response = await axios.post(url_upload_usecase, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              role: this.userData.role,
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          });

          // Handle the response from the server as needed
          console.log("File upload response:", response.data);
          console.log("filename : ", fileName);

          this.alertSukses();
        } catch (error) {
          // Handle errors, e.g., display an error message to the user
          alert(error.message);
          if (error.response.data != null) {
            alert(error.response.data.message);
          }
          this.isLoading = false;
          console.error("Error uploading file:", error);
          // this.$router.go(this.$router.currentRoute)
        }
      }
    },

    clickSimpan() {
      this.isLoading = true;

      // const fileDokumenTOR = this.$refs.fileDokumenTOR.files[0]

      this.simpanEditKontraktor();
    },
    validasiForm() {
      // if (
      //     this.formValues.namaKontraktor == "" ||
      //     this.formValues.nomorNIB == "" ||
      //     this.$refs.fileDokumenNIB.value == ""
      // ) {
      //     if (this.kontraktor.fileNib != null) {
      //         if (this.wajibIUJP == true) {
      //             if (
      //                 this.formValues.nomorIUJP == "" ||
      //                 this.formValues.masaBerlakuIUJP == "" ||
      //                 (this.$refs.fileDokumenIUJP.value == "" &&
      //                     this.kontraktor.fileIujp == null)
      //             ) {
      //                 return false
      //             } else {
      //                 if (
      //                     this.formValues.nomorIUJP != "" &&
      //                     this.formValues.masaBerlakuIUJP != "" &&
      //                     this.kontraktor.fileIujp != null
      //                 ) {
      //                     return true
      //                 } else {
      //                     return false
      //                 }
      //             }
      //         }
      //         return true
      //     }
      //     return false
      // } else {
      //     return true
      // }
    },

    alertSukses() {
      Swal.fire({
        title: "Edit Kontrak Sukses",
        text: "Data Kontrak telah dtambahkan !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    handleChangeFile(refFile) {
      let file = null;
      if (refFile == "dokumenTOR") {
        file = this.$refs.fileDokumenTOR.files[0];
      }

      if (file) {
        // Check file type
        if (file.type !== "application/pdf") {
          this.validasiFile.type = true;
          this.validasiFile.size = false;
          this.$refs.fileDokumenTOR.value = "";
          return;
        }

        // Check file size ({{max_file_size}}MB limit)
        if (file.size > max_file_size * 1024 * 1024) {
          this.validasiFile.type = false;
          this.validasiFile.size = true;
          this.$refs.fileDokumenTOR.value = "";
          return;
        }

        // Reset error messages if the file is valid
        this.validasiFile.type = false;
        this.validasiFile.size = false;

        // Handle the valid file as needed (e.g., store the file)
        console.log("Valid file:", file);
      }
    },
    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    updateAmount(event) {
      let numericValue = event.target.value.replace(/[^0-9]/g, "");
      this.formValues.nilaiKontrak = this.formatCurrency(numericValue);
    },
    formatCurrency(value) {
      if (typeof value === "string") {
        value = parseInt(value, 10);
      }

      if (!Number.isNaN(value)) {
        return "Rp. " + value?.toLocaleString("id-ID");
      } else {
        return "Rp. 0";
      }
    },
  },
};
</script>
